export class TestGroupSystemsStatus {
    systemid: string;
    issystemassignedtotestgroup: string;
    errormessage: string;
    statuscode: string;
}


// WEBPACK FOOTER //
// ./app/admin/models/testgroupsystemsstatus.ts